module.exports = __webpack_public_path__ + "img/10th_jobs-and-careers.03de237b.webp";